module.exports = __webpack_public_path__ + "assets/img/gfpd1.1047b373.png";